<template>
<div class="chapter">
<div class="inner_page">
<div id="epub4231-6.html" xml:lang="en-US">
<div class="Basic-Text-Frame">
<p class="CN para-style-override-1" id="toc_marker-7" xml:lang="en-GB"><span class="char-style-override-1">Revenge is a kind of grace . . .</span></p>
<p class="EPIS-align">Tim Lott, <span class="char-style-override-4">Under the Same Stars</span></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epub4231-6.vue?fbd16ee4